export class ArrearsModel {
  ClientParentRef: number;
  ClientParent: string;
  ClientRef: number;
  Client: string;
  PropertyRef: number;
  Property: string;
  TenantRef: number;
  Tenant: string;
  DebtorRef: string;
  Debtor: string;
  ManagerCode: string;
  ManagerName: string;
  CountryCode: string;
  Total: number;
  SubLedgerAmount: number;
  SubLedgerCode: string;
  SubLedger: string;
  Age: string;
  AsAtDate: Date;
  PaymentPlan: string;
  PropertyGroupCode: string;
  PropertyGroup: string;
  PropertyTypeCode: string;
  PropertyType: string;
  LocationCode: string;
  Location: string;
  PropertyAnalysisCode: string;
  PropertyAnalysis: string;
  SiteRef: number;
  Site: string;
  CurrencyCode: string;
}

export class ArrearsTable {
  xAxisLabels: string[];
  rows: ArrearsModel[];

  constructor(xAxisLabels: string[], rows: ArrearsModel[]) {
    this.xAxisLabels = xAxisLabels;
    this.rows = rows;
  }

}
